import React, {Component} from "react";
import Header from "./Header";
import ReactLoading from "react-loading";
import {filterTransactionTypes, getLabelByValue} from "../../util/Helpers";
import Body2 from "./Body2";

class DividedTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			paginationEnabled: false,
		};
		this.orderBy = this.orderBy.bind(this);
		this.pageSize = this.pageSize.bind(this);
	}

	orderBy(accessor, direction) {
		this.setState({accessor: accessor, direction: direction});
		if (!!this.props.fetchData)
			this.props.fetchData(accessor, direction, this.state.page, this.state.size);
	}

	pageSize(page, size) {
		this.setState({page: page, size: size});
		if (!!this.props.fetchData)
			this.props.fetchData(this.state.accessor, this.state.direction, page, size);

	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.manual === true && !!this.props.fetchData) {
			this.setState({page: nextProps.page, size: nextProps.size});
			this.props.fetchData(this.state.accessor, this.state.direction, nextProps.page, nextProps.size);
		}
	}

	render() {
		let expenseTypes=this.props.transactionTypes?filterTransactionTypes( this.props.transactionTypes,"EXPENSE"):[];
		let incomeTypes=this.props.transactionTypes?filterTransactionTypes(  this.props.transactionTypes,"INCOME"):[];

		console.log("props:",this.props);
		return (
			<div>
				<div className="row col-sm-12">
					<table style={this.props.style} className="col-sm-6">
						<Header columns={this.props.columns1}/>
						{this.props.loading
							?  (<tbody>
							<tr>
								<td colSpan={this.props.columns1.length}>{this.props.loadingText ? this.props.loadingText :
									<ReactLoading type="spinningBubbles" style={{width:"70px", height: "70px", margin: "20px auto 0 auto", fill: "#888"}}/>}</td>
							</tr>
							</tbody>)
							: <Body2 columns={this.props.columns1}
									 items={this.props.content}
									 types={incomeTypes}
									 emptyMessage={this.props.emptyMessage || "Kayıt bulunamadı."}
									 getTrStyles={this.props.getTrStyles}
									 getTrClass={this.props.getTrClass}
									 statSums={getLabelByValue(this.props.statSums,"INCOME") +' ₺'}
							/>
						}
					</table>
					<table style={this.props.style} className="col-sm-6">
						<Header columns={this.props.columns2} />
						{this.props.loading
							?  (<tbody>
							<tr>
								<td colSpan={this.props.columns2.length}>{this.props.loadingText ? this.props.loadingText :
									<ReactLoading type="spinningBubbles" style={{width:"70px", height: "70px", margin: "20px auto 0 auto", fill: "#888"}}/>}</td>
							</tr>
							</tbody>)
							: <Body2 columns={this.props.columns2}
									 items={this.props.content}
									 types={expenseTypes}
									 emptyMessage={this.props.emptyMessage || "Kayıt bulunamadı."}
									 getTrStyles={this.props.getTrStyles}
									 getTrClass={this.props.getTrClass}
									 statSums={getLabelByValue(this.props.statSums,"EXPENSE") +' ₺'}
							/>
						}
					</table>
				</div>
			</div>
		);
	}
}

export default DividedTable;



// WEBPACK FOOTER //
// ./src/components/Table/DividedTable.js